import { AlarmLog, Alarm } from "../../services/types/fleet-alarms-service.types";

export enum AlarmRankWeight {
    //Weather alarms have highest prirority
    ParametricRoll = 60,
    HeavyWeather = 55,
    WRSafetyAlert = 40,
    WRPerformanceAlert = 40,
    WRReject = 40,
    Stoppage = 14,
    Speed = 13,
    Crosstrack = 12,
    NoPlan = 2,

}

export type VesselRank = {
    latestAlarmTs: string,
    rankWeight: AlarmRankWeight
}

export interface FleetAlarmLog extends AlarmLog {
    userData?: {
        displayName?: string,
        email?: string
    }
}

interface AllAlarmsLogs {
    note?: string
    reason: string
    reasonSource: string
    createdAt: string
}

export interface FleetAlarm extends Alarm {
    notification_responses?: any[]
    state?: string;
    type?: string;
    alarmLogs: FleetAlarmLog[];
    //TODO: align if this property can be undefined
    allAlarmLogs?: AllAlarmsLogs[];
    planId?: number;
}

export enum AlarmEvents {
    AlarmsUpdated = "alarms-updated",
    AlarmUpdateFailed = "alarm-update-failed",
    AlarmRanksUpdated = "alarm-ranks-updated",
    WeatherAlarmsUpdated = "weather-alarms-updated",
    CheckMoreAlarms = "check-more-alarms",
    WeatherAlarmAcceptedByOtherVET = "weather-alarm-accepted-by-other-VET",
    NotificationSenderAlarmsUpdated = "notification-sender-alarms-updated",
}

export enum NotificationEvents {
    NotificationsUpdated = "notifications-updated",
}

export type AllAlarmLogs = {
    note?: string,
    reason?: string,
    reasonSource?: string
}

export type NotificationResponses = {
    data: string,
    ends_at: string,
    notification_id: string,
    state: string,
    id: string,
    source: string
}

export enum FilterEvents {
    FilterSaved = 'filter-saved',
}